import {isFeatureEnabled} from '@github-ui/feature-flags'
import type {ReactNode} from 'react'

import styles from './ContentWrapper.module.css'

export function ContentWrapper({children, alwaysWrap = false}: {children: ReactNode; alwaysWrap?: boolean}) {
  if (!alwaysWrap && isFeatureEnabled('issues_sticky_header')) {
    return <>{children}</>
  }
  return <div className={styles.contentContainer}>{children}</div>
}
